import React from "react";

import { TimeLineBody } from "./TimeLineBody";
import { TimeLineHeader } from "./TimeLineHeader";
import { TransitionWrapper } from "./TransitionWrapper";

export const TimeLineItem = ({ year, onClick, onKeyDown }) => {
  return (
    <div className="timeline-item">
      <TimeLineHeader
        expanded={year.expanded}
        headerText={year.age}
        subHeaderText={year.descriptor}
        onClick={onClick}
        onKeyDown={onKeyDown}
      />

      <TransitionWrapper show={year.expanded}>
        <TimeLineBody events={year.events} age={year.age} />
      </TransitionWrapper>
    </div>
  );
};
